import React from 'react';
import { Button } from 'react-bootstrap';
import { FiCopy, FiLayout, FiRefreshCw } from 'react-icons/fi';

import { GUIDE_HTML_CLASS_REFERENCE_GROUPS } from '../utils/guideHtmlAuthoring';

type GuideHtmlAuthoringHelpProps = {
  onCopyTemplate: () => void;
  onUseTemplate: () => void;
  statusMessage?: string;
};

export default function GuideHtmlAuthoringHelp({
  onCopyTemplate,
  onUseTemplate,
  statusMessage,
}: GuideHtmlAuthoringHelpProps) {
  return (
    <section className="guide-authoring-help" aria-label="Rich HTML authoring help">
      <div className="guide-authoring-help-header">
        <div className="guide-authoring-help-copy">
          <span className="guide-authoring-help-kicker">Save-safe rich content</span>
          <h3>Use built-in guide classes instead of inline styles</h3>
          <p>
            This editor supports semantic HTML plus the class names below. Avoid full HTML documents,
            style tags, and inline CSS so the content stays save-safe in staging and production.
          </p>
        </div>
        <div className="guide-authoring-help-actions">
          <Button onClick={onCopyTemplate} variant="light">
            <FiCopy />
            Copy starter markup
          </Button>
          <Button onClick={onUseTemplate} variant="secondary">
            <FiLayout />
            Use starter template
          </Button>
        </div>
      </div>

      {statusMessage ? <p className="guide-authoring-status">{statusMessage}</p> : null}

      <div className="guide-authoring-group-grid">
        {GUIDE_HTML_CLASS_REFERENCE_GROUPS.map(group => (
          <article className="guide-authoring-group-card" key={group.title}>
            <h4>
              <FiRefreshCw aria-hidden />
              {group.title}
            </h4>
            <div className="guide-authoring-token-list">
              {group.items.map(item => (
                <div className="guide-authoring-token" key={item.name}>
                  <code>{item.name}</code>
                  <span>{item.description}</span>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
